<template>
    <div class="qualification-field">
        <div class="joy-font-primary-350 joy-mb-2 qualification-field__title">
            {{ title }}
            <VJoyTooltip v-if="showAuthorAndDate">
                <span class="qualification-field__title__author-and-date">{{ lastEdition }}</span>
                <template #tooltip-content>
                    {{ lastEditionTooltip }}
                </template>
            </VJoyTooltip>
        </div>
        <div class="qualification-field__inner">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {intlFormatDistance} from 'date-fns';
    import {useLocale} from '#imports';
    import {VJoyTooltip} from '@maltjoy/core-vue';
    import type {StringQualificationField} from '@api';

    const props = defineProps<{
        title: string;
        fieldAuthorAndDate?: StringQualificationField;
    }>();

    const {locale} = useLocale();

    const showAuthorAndDate = computed(() => props.fieldAuthorAndDate && props.fieldAuthorAndDate.updateDate && props.fieldAuthorAndDate.author);

    const lastEdition = computed(() =>
        showAuthorAndDate.value
            ? props.fieldAuthorAndDate!.author!.name +
              ' · ' +
              intlFormatDistance(props.fieldAuthorAndDate!.updateDate!, new Date(), {locale: locale.value})
            : '',
    );
    const lastEditionTooltip = computed(() => (showAuthorAndDate.value ? props.fieldAuthorAndDate!.updateDate! : ''));
</script>

<style scoped lang="scss">
    .qualification-field {
        padding: var(--joy-core-spacing-3) var(--joy-core-spacing-4);
        border-radius: var(--joy-core-radius-4);
        background-color: var(--joy-color-neutral-20);
        display: inline-block;

        &__title {
            display: flex;
            gap: var(--joy-core-spacing-2);

            &__author-and-date {
                color: var(--joy-color-neutral-40);
                font-size: var(--joy-font-size-primary-200);
                font-weight: lighter;
            }
        }
    }
</style>
